import ArrowLeftIcon from '@/assets/icons/arrow-left.svg?react';
import ArrowRightIcon from '@/assets/icons/arrow-right.svg?react';
import styles from './OrdersPagination.module.scss';

interface IProps {
  offset: number;
  pageSize: number;
  total: number;
  // eslint-disable-next-line no-unused-vars
  onOffsetChange: (offset: number) => void;
}

export default function OrdersPagination({ offset, pageSize, total, onOffsetChange }: IProps) {
  const firstOrder = total ? offset + 1 : 0;
  const lastOrder = Math.min(offset + pageSize, total);
  const showPrevious = offset > 0;
  const showNext = offset + pageSize < total;

  return (
    <nav className={styles.pagination}>
      {showPrevious && (
        <button type="button" aria-label="Previous page" onClick={() => onOffsetChange(offset - pageSize)}>
          <ArrowLeftIcon />
        </button>
      )}
      <span>{`${firstOrder}-${lastOrder} of ${total.toLocaleString()}`}</span>
      {showNext && (
        <button type="button" aria-label="Next page" onClick={() => onOffsetChange(offset + pageSize)}>
          <ArrowRightIcon />
        </button>
      )}
    </nav>
  );
}
